import { render } from "./app-form-telephone-no.vue?vue&type=template&id=d5a13406&scoped=true"
import script from "./app-form-telephone-no.vue?vue&type=script&lang=js"
export * from "./app-form-telephone-no.vue?vue&type=script&lang=js"

import "./app-form-telephone-no.vue?vue&type=style&index=0&id=d5a13406&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a13406"]])

export default __exports__